var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list_page_layout"},[_c('AppHeaderVue'),_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"privcyPolicy"},[_c('h2',[_vm._v("Privacy Policy ")]),_vm._v(" "+_vm._s(_vm.info.description)+" ")])]),_c('AppFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }